import React, { Component } from 'react';
import styled from 'styled-components';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { getStorage, setStorage } from 'utils/storage';
import { FormattedMessage } from 'react-intl';
import logo from './img/nav_logo.png';

import './index.less';

const WrapMenu = styled(Menu)`
  margin-left: 395px !important;
`;
const WrapLogo = styled.span`
  position: absolute;
  left: 0;
  width: 94px;
  height: 38px;
  top: 50%;
  left: 16px;
  margin-top: -19px;
  img {
    width: 94px;
    height: 38px;
  }
`;

interface IProps {
  name?: string;
  pathname?: string;
}

interface IState {
  page: string;
}

export default class Header extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      page: 'game',
    };
  }

  componentDidMount() {
    const { pathname } = this.props;
    this.checkMenu(pathname);
  }

  componentWillReceiveProps(nextProps) {
    const { pathname: oldPathname } = this.props;
    const { pathname } = nextProps;
    if (oldPathname !== pathname) {
      this.checkMenu(pathname);
    }
  }

  checkMenu = pathname => {
    if (pathname.match(/\/game/)) {
      this.setState({
        ...this.state,
        page: 'game',
      });
    } else if (pathname.match(/\/subscribe/)) {
      this.setState({
        ...this.state,
        page: 'subscribe',
      });
    } else if (pathname.match(/\/setting/)) {
      this.setState({
        ...this.state,
        page: 'setting',
      });
    }
  };

  triggerLanguage = () => {
    setStorage('locale', getStorage('locale') === 'en' ? 'zh' : 'en');
    window.location.reload();
  };
  onClickMenu = val => {
    return false;
  };
  render() {
    const { page } = this.state;
    return (
      <header className="shopify-app-header">
        <div className="main-content">
          <WrapLogo>
            <img alt="logo" src={logo}></img>
          </WrapLogo>
          <WrapMenu
            mode="horizontal"
            selectedKeys={[page]}
            onClick={this.onClickMenu}
          >
            <Menu.Item key="track-list">
              <Link to="/track-list">
                <FormattedMessage id="MENU_GAME" />
              </Link>
            </Menu.Item>
            <Menu.Item key="track-faq">
              <Link to="/track-faq">
                <FormattedMessage id="MENU_SUBSCRIBE" />
              </Link>
            </Menu.Item>
            <Menu.Item key="track-video">
              <Link to="/track-video">
                <FormattedMessage id="MENU_SETTING" />
              </Link>
            </Menu.Item>
          </WrapMenu>
          <span className="fr lang-box" onClick={this.triggerLanguage}>
            {getStorage('locale') === 'en' ? '中文' : 'English'}
          </span>
        </div>
      </header>
    );
  }
}
